module.exports = __webpack_public_path__ + "static/media/AlbanyAdvertiser-socshare-min.40d35bf3.jpg";